// 事件分析 function
import { debounce as _debounce } from 'lodash';
import { SendEventAnalyticsAPI } from 'api/site-analyze/EventAnalytics';
/**
 * 發送事件分析資料
 * @param {object} params - 事件參數物件
 * @param {string} params.eventType - 事件類型
 * @param {string|number} params.userId - 使用者 ID
 * @param {object} [params.payload] - 額外的資料物件
 * @param {string|number} [params.payload.affiliatedID] - 關聯 ID
 * @returns {Promise<void>}
 */
export const sendEventAnalytics = async ({ eventType, userId, ...payload }) => {
	if (!eventType || userId == null) {
		// console.warn('[⚠️ 事件分析] 缺少 eventType 或 userId');
		return;
	}

	if (payload.affiliatedID != null) {
		payload.affiliatedID = String(payload.affiliatedID);
	}

	const dataToSend = {
		eventType,
		userId: String(userId),
		payload: {
			...payload,
		},
	};

	// console.log('[📡 事件分析]', dataToSend);
	// console.log('[🚨 傳送前檢查]', JSON.stringify(dataToSend, null, 2));
	try {
		const res = await SendEventAnalyticsAPI(dataToSend);
		if (res?.status === 'success') {
			// console.log('發送成功', res);
			return;
		}
		if (res?.status === 'error') {
			console.error(`[❌ API 回傳錯誤] code=${res.error?.code}`, res);
			return;
		}
	} catch (err) {
		console.error('[❌ 發送事件分析失敗]', err);
	}
};

// debounce 版本
export const debouncedSendEventAnalytics = _debounce(async params => {
	try {
		await sendEventAnalytics(params);
	} catch (err) {
		console.error('[❌ Debounced 發送事件分析失敗]', err);
	}
}, 300);
